module.exports = "<div #htmlContainer [innerHtml]=\"htmlContent | safeHtml\">{{textContent}}</div>\r\n"